import Close from '../../../assets/close.svg';

const CloseIcon: React.FC<React.SVGProps<SVGSVGElement> & { color?: string }> = ({ color, ...props }) => (
  <Close fill={color} {...props} />
);

export default CloseIcon;
